export default __webpack_public_path__ + "static/media/banner_school_date.4ad0d993.gif";